import React, { useMemo } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

import { buildLeafletLayer, buildLeafletLayerFromCswGeom } from 'src/scenes/Project/scenes/Analytics/smaAnalyticsHelper';
import { Cards, MapWrapper } from 'src/components';
import { getColorScheme } from 'src/utils/colorBrewer';
import { getCombinedBounds } from 'src/components/map/mapHelper';
import { CategoryEeccIcon } from 'src/scenes/Project/scenes/Dashboard/components/CategoryEeccIcon';


const columns = [
  {
    title: 'Piso',
    field: 'name',
    width: '50%',
  },
  {
    title: 'Formación',
    field: 'formation',
    width: '20%',
  },
  {
    title: 'Criterio A2B',
    width: '10%',
    render: ({ uicnA2b }) => <CategoryEeccIcon category={uicnA2b} />,
  },
  {
    title: 'Criterio A3 ',
    width: '10%',
    render: ({ uicnA3 }) => <CategoryEeccIcon category={uicnA3} />,
  },
  {
    title: 'Criterio final',
    width: '10%',
    render: ({ uicnFinal }) => <CategoryEeccIcon category={uicnFinal} />,
  },
];

const heightVH = n => document.documentElement.clientHeight * (n / 100);

const mapOptions = {
  center: [ -32.48431324745671, -71.25296320202341 ],
  zoomControl: true,
  dragging: true,
  zoom: 16,
  doubleClickZoom: false,
  attributionControl: false,
};

const useStyles = makeStyles(theme => ({
  map: {
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
  },
  container: {
    maxHeight: `${interestAreaMapHeight}vh`,
    overflowY: 'auto',
  },
}));

const interestAreaMapHeight = 50;

const Pliscoff = ({ pliscoff, interestArea = [] }) => {

  const pliscoffData = useMemo(() => pliscoff.data || { results: [], box: null }, [ pliscoff.data ]);

  const pliscoffCount = pliscoff.data.results.length;

  const interestAreaLayers = useMemo(() =>
    interestArea.map(ia => buildLeafletLayer({
      features: ia.geojson,
      id: ia.id,
      name: ia.name,
    }))
  , [ interestArea ]);

  const colors = useMemo(() => getColorScheme(pliscoffData.results.length), [ pliscoffData.results.length ]);

  const pliscoffLayers = useMemo(() =>
    pliscoffData.results.map((pl, index) =>
      buildLeafletLayerFromCswGeom({
        features: [ pl.cswFeatGeom ],
        id: pl.code,
        name: pl.name,
        style: {
          weight: 2,
          fillOpacity: 0.8,
          color: colors[index],
          fillColor: colors[index],
        },
      }),
    )
  , [ pliscoffData, colors ]);

  const classes = useStyles();

  const interestAreaBounds = getCombinedBounds(interestAreaLayers);

  const hasInterestArea = interestArea.length > 0;

  return (
    <Box mt={1}>
      {hasInterestArea &&
        <MapWrapper
          id="pliscoff-map"
          className={classes.map}
          options={mapOptions}
          height={heightVH(interestAreaMapHeight)}
          layers={[ ...pliscoffLayers, ...interestAreaLayers ]}
          box={pliscoffData.box}
          bounds={interestAreaBounds}
        />
      }
      <Box mt={1} mb={3}>
        <Typography variant="caption" color="textPrimary">El área de interés interseca con {pliscoffCount} pisos vegetacionales</Typography>
      </Box>
      <Box className={classes.container}>
        <Cards values={pliscoffData.results} columns={columns} variant="condensed" />
      </Box>
    </Box>
  );
};

Pliscoff.propTypes = {
  pliscoff: PropTypes.object,
  interestArea: PropTypes.array,
};


export {
  Pliscoff,
};
